@if (vm.helpEnabled) {
<div class="help-form" [formGroup]="vm.helpForm" [attr.data-qa]="vm.qaHelpForm">
  <div class="help-form__title">{{vm.helpTitle}}</div>
  @if (vm.helpRequestSubmitted) {
    <jui-svg-icon [name]="'document'"></jui-svg-icon>
    <div class="help-form__message">
      {{vm.helpPostSubmitMessage}}
    </div>
  } @else {
    <div class="help-form__message">
      {{vm.helpPreSubmitMessage}}
    </div>
    <div class="help-form__input">
      <jui-input formControlName="firstName" [label]="vm.helpFirstNameFormLabel" size="xl" required [errors]="vm.helpForm.get('firstName')?.errors" [messages]="vm.helpMessages" [dataqastring]="vm.qaFirstNameInput"></jui-input>
    </div>
    <div class="help-form__input">
      <jui-input formControlName="lastName" [label]="vm.helpLastNameFormLabel" size="xl" required [errors]="vm.helpForm.get('lastName')?.errors" [messages]="vm.helpMessages" [dataqastring]="vm.qaLastNameInput"></jui-input>
    </div>
    <div class="help-form__input">
      <jui-input formControlName="email" [label]="vm.helpEmailFormLabel" size="xl" type="email" required [errors]="vm.helpForm.get('email')?.errors" [messages]="vm.helpMessages" [dataqastring]="vm.qaEmailInput"></jui-input>
    </div>
    <div class="help-form__input">
      <jui-input formControlName="phoneNumber" [label]="vm.helpPhoneNumberFormLabel" size="xl" type="tel" required [errors]="vm.helpForm.get('phoneNumber')?.errors" [messages]="vm.helpMessages" [dataqastring]="vm.qaPhoneNumberInput"></jui-input>
    </div>
    <div class="help-form__input">
      <jui-textarea formControlName="comment" [label]="vm.helpCommentFormLabel" [maxlength]="150" size="xl" [dataqastring]="vm.qaCommentInput"></jui-textarea>
    </div>
  }
</div>

}
